import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { captureError } from "@/ErrorHandlers"
import { DeliveryOrderExportStatus } from "@/reducers/deliveryOrderExportStatusesSlice"
import {
  parseDeliveryOrderExportStatusItem,
  SLT_DELIVERY_ORDER_EXPORTS_NODE,
} from "@/lib/deliveryOrderExportStatusPubSubParser"

export const retrieveAllDeliveryOrderExportStatuses = async (
  xmpp: Client,
): Promise<DeliveryOrderExportStatus[]> => {
  const result = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: SLT_DELIVERY_ORDER_EXPORTS_NODE,
    timeout: 4000,
  })

  const items =
    (result
      .getChild("pubsub")
      ?.getChild("items")
      ?.getChildren("item") as Element[]) ?? []

  return items.flatMap((item) => parseDeliveryOrderExportStatusItem(item) ?? [])
}

export const subscribeToDeliveryOrderExports = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(
      client,
      wizardJid(client.jid!),
      SLT_DELIVERY_ORDER_EXPORTS_NODE,
    )
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      captureError(error, {
        origin: "XMPPOnOnline",
        extra: { message: "subscribeToDeliveryOrderExports" },
      })
    }
  }
}
